module.exports = __webpack_public_path__ + "static/media/ava.bc6f2115.png";